export const loginPath = "/login";

export const accesses = {
  novaPoshta: [2002, 2006, 1985, 2176, 2008, 2003], //2002 devs
  cards: [1143, 2002, 1985, 2005, 2176, 2008, 2003],
  statistic: [1143, 2002, 1985, 2005, 2176, 2008, 2003],
  predictions: [2002, 1985, 2176, 2008, 2003],
};
